import { useId, type SelectHTMLAttributes } from 'react';
import './ui.css';

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'id'> {
  label: string;
  options: readonly SelectOption[];
  /** Keeps the label in the accessibility tree but hides it, for a control
   *  whose meaning is already carried by a table column header. */
  labelHidden?: boolean;
}

export function SelectField({
  label,
  options,
  labelHidden,
  className,
  ...rest
}: SelectFieldProps) {
  const id = useId();

  return (
    <div className="ui-field">
      <label
        className={labelHidden ? 'sr-only' : 'ui-field__label'}
        htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={['ui-field__control', className ?? ''].filter(Boolean).join(' ')}
        {...rest}>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
